import React, { Component } from 'react';
import './../css/master.css';
import './../css/maintainTransporter.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
 
var httpURL = '';
var querystring = require('querystring');

var transporterIdCol 	= 'td:eq(0)';
var transporterCol 		= 'td:eq(1)';
var contactPersonCol 	= 'td:eq(2)';
var contactCityCol 	    = 'td:eq(3)';
var transporterPhone 	= 'td:eq(4)';
var lstTransport 		= [];
var lstCity             = [];
var flag				= true;
class MaintainTransporter extends Component {
    constructor(props) {
        super(props);
        this.state ={
			transport:[],
			city:[],
			width:'97.5%',
			loader:'none',
			opacity:1,
        }
        this.maintainTransport = this.maintainTransport.bind(this);
        //this.generatePassword = this.generatePassword.bind(this);
      }
     
	componentDidMount =()=> {
		this.setState({loader:'block', opacity:0.5});
		axiosInstance.get(httpURL+'/a/mst/tpt/list', {
			withCredentials:true
		}).then((response) => {
            if(response.data.SvcStatus === 'Success'){	
				this.setState({
					transport: response.data.lstTpt,
				});
				lstTransport = this.state.transport;
				this.setTransporterTable();
			}else{
				toast.error(response.data.SvcMsg);
				if(response.data.SvcMsg == 'You are not logged in'){
					window.location.href = window.CSURL;
					return false;
				}
			}
		}).catch((e) => {
            toast.error('Service failed: '+e);
		});
		
		axiosInstance.get(httpURL+'/a/mst/cty/list',{
			withCredentials: true
		}).then((response)=> {
			  if(response.data.SvcStatus === 'Success'){
				  this.setState({
					  city:response.data.lstCity,
				  })
				  lstCity = this.state.city;
				  this.fillCityCmb();
			  }
			  else{
				  toast.error(response.data.SvcMsg);
			  }
			  this.setState({loader:'none', opacity:1});
		  }).catch((error)=> {
			  toast.error("Service failed " + error);
		});

		this.handleResize();
		window.addEventListener("load", this.handleResize);
		window.addEventListener("resize", this.handleResize);
	}	
	
	handleResize=()=>{
		var width = ($('.tableLayout1').parent().width())-18;
		this.setState({width:width})
	}
	fillCityCmb =()=>{
		$('#inp_contactCity').empty();
		$('#inp_contactCity').prepend($("<option> </option>").val(0).html('City'));
		for(var i=0; i<lstCity.length; i++){
			var cityId 	= lstCity[i].cityId;
			var city  	= lstCity[i].city;
			$('#inp_contactCity').append($("<option> </option>").val(cityId).html(city)); 
		}
	}
	
	setTransporterTable=()=>{
		$('#transportTableBody tr').remove();
		var table 				= document.getElementById('transportTable');
		var tbody 				= document.getElementById('transportTableBody');
		var filterId 			= $("#transportId").val();
		var filterTransporter 	= $("#transporter").val().toLowerCase();
		var filterPerson 		= $("#transportContactPerson").val().toLowerCase();
		var filterCity 		    = $("#transportCity").val().toLowerCase();
		
		var filterPhone 		= $("#transportPhone").val().toLowerCase();
		
		for(var i=0; i<lstTransport.length; i++){
			var tptId		= lstTransport[i].tptId;
			var tpt 		= lstTransport[i].tpt;
			var conPerson	= lstTransport[i].contactPerson;
			var cityId		= lstTransport[i].cityId;
			var city		= lstTransport[i].city;
			var phoneNo		= lstTransport[i].phoneNo;
			
			var row = document.createElement('tr');
			row.onclick=(e)=>{
				flag = false;
				$(e.target).closest('tr').addClass('selected').siblings().removeClass('selected');
				var tptId = $(e.target).closest('tr').find(transporterIdCol).text();
				this.setTransportForm(tptId);
			}
			
			
			if(tptId.toString().indexOf(filterId) == -1)
				continue;
			if(tpt.toLowerCase().indexOf(filterTransporter) == -1)
				continue;
			if(conPerson.toLowerCase().indexOf(filterPerson) == -1)
				continue;
			if(city.toLowerCase().indexOf(filterCity) == -1)
				continue;
			if(phoneNo.toLowerCase().indexOf(filterPhone) == -1)
				continue;
			
			this.addTD(row, tptId, 'txtright');
			this.addTD(row, tpt, '');
			this.addTD(row, conPerson, '');
			this.addTD(row, city, '');
			this.addTD(row, phoneNo, '');
			
			tbody.append(row);
		}
		table.append(tbody);	
	}  
	
	addTD(row, val, classname){
		var cell = document.createElement('td');
		var text = document.createTextNode(val);
		cell.className = classname;
		cell.append(text);
		row.append(cell);
	}
	clear=(e)=>{
		flag = true;
        $("#transportAddForm")[0].reset();
       // this.setState({flag:true});
    }
	maintainTransport =()=>{
		var tpt	=	{};
		var transporter		= $('#inp_transporter').val();
		var contactPerson	= $('#inp_contactPerson').val();
		var cityId          = $('#inp_contactCity').find("option:selected").val();
		var city            = $('#inp_contactCity').find("option:selected").text();
		var phone			= $('#inp_phone').val();
		
		if(transporter == ''){
			toast.warning('Please fill transporter name');
			document.getElementById("inp_transporter").focus();
			return false;
		}

		if(contactPerson == ''){
			toast.warning('Please fill contact person');
			document.getElementById('inp_contactPerson').focus();
			return false;
		}

		if(cityId == 0){
			toast.warning('Please select City');
			document.getElementById("inp_contactCity").focus();
			return false;
		}
		
		
		if(phone == ''){
			toast.warning('Please fill phone number');
			document.getElementById("inp_phone").focus();
			return false;
		}
		
		if(phone.length != 10){
			toast.warning('Phone number should be 10 digits only');
			document.getElementById("inp_phone").focus();
			return false;
		}
		
		if(isNaN(phone)){
			toast.warning('Phone number should be numeric');
			document.getElementById("inp_phone").focus();
			return false;
		}
		
		tpt.tptId = 0;
		tpt.tpt = transporter;
		tpt.contactPerson = contactPerson;
		tpt.cityId =  cityId;
		tpt.phoneNo = phone;
	
		if(flag === true){
			this.setState({loader:'block', opacity:0.5});
			axiosInstance.post(httpURL+'/a/mst/tpt/save',
				querystring.stringify({'tpt':JSON.stringify(tpt)}), {withCredentials:true}
			).then((response)=>{
				if(response.data.SvcStatus === "Success"){
					toast.success(response.data.SvcMsg);
					tpt.tptId = response.data.tptId;
					tpt.city = city;
					lstTransport.push(tpt);
					this.setTransporterTable();
					this.setTransportForm(response.data.tptId);
				    this.highlightRow('transportTableBody', response.data.tptId)
					flag = false;
				}
				else{
					toast.error(response.data.SvcMsg);
				}
				this.setState({loader:'none', opacity:1});	 
			}).catch((e)=>{
				toast.error('Service failed: '+e);
			});
		}else{
			var tptId = $('#transportTableBody tr.selected').find(transporterIdCol).text();
			
			if(tptId == ''){
				toast.warning('Please select row');
				return false;
			}
			
			tpt.tptId = tptId;
			tpt.city = city;
			this.setState({loader:'block', opacity:0.5});
			axiosInstance.post(httpURL+'/a/mst/tpt/save',
				querystring.stringify({'tpt':JSON.stringify(tpt)}), {withCredentials:true}
			).then((response)=>{
				if(response.data.SvcStatus == 'Success'){
					toast.success(response.data.SvcMsg);
					var transIdx = this.getIdxTransport(tptId);
					lstTransport.splice(transIdx,1,tpt);
					this.setTransporterTable();
					this.setTransportForm(tptId);
					this.highlightRow('transportTableBody', tptId);
				}else{
					toast.error(response.data.SvcMsg);
				}
				this.setState({loader:'none', opacity:1}); 
			}).catch((e)=>{
				toast.error('Service failed: '+e);
			});
		}
	}
	
	getIdxTransport(id){
		for(var i=0; i<lstTransport.length; i++){
			if(lstTransport[i].tptId == id){
				return i;
			}
		}
		return -1;
	}
	
	setTransportForm=(id)=>{
		var transportData = this.getTransportData(id);
		if(transportData != -1){
			$('#inp_transporter').val(transportData.tpt);
			$('#inp_contactPerson').val(transportData.contactPerson);
			$('#inp_contactCity').val(transportData.cityId);
			$('#inp_phone').val(transportData.phoneNo);
		}
	}
	
	getTransportData(id){
		for(var i=0; i<lstTransport.length; i++){
			if(lstTransport[i].tptId == id){
			   return lstTransport[i];
			}
		}
		return -1;
	}
	
	highlightRow(table, id){
		$('#'+table+' tr').each(function(){
			var transId = $(this).find(transporterIdCol).text();
			if(transId == id){
				$(this).addClass('selected').siblings().removeClass('selected');
			}
		});
	}  
  
	render(){
		httpURL = window.httpURL;
		return(
			<div style={{height:'100%'}}>
				<Header />
				<ToastContainer autoClose={2000} hideProgressBar />
				<div style={{position:'fixed', width:100, height:100, marginLeft:-50, marginTop:-50, left:'50%', top:'50%', display:this.state.loader}}>
					<img src={require("../images/loader.gif")} alt="Loader..."/>
				</div>
				<div className="main" style={{opacity:this.state.opacity}}>
					<div className="container-fluid">
						<div className="col-sm-11 col-centered">
							<div className="col-sm-7 col-xs-11 padding-remove">
								<table className="tableLayout1"  style={{width:this.state.width}}>
									<thead>
										<tr>
											<th style={{width:5, display:'none'}}>Staff Id</th>
											<th style={{width:110}}> <input type= "text"  onChange = {this.setTransporterTable} className= "form-control inp-search" id="transportId"  placeholder= "Transporter Id"/></th>
											<th style={{width:130}}> <input type= "text"  onChange = {this.setTransporterTable} className= "form-control inp-search" id="transporter" placeholder= "Transporter" /></th>
											<th style={{width:150}}>  <input type= "text"  onChange = {this.setTransporterTable} className= "form-control inp-search" id="transportContactPerson" placeholder= "Contact Person" /></th>
											<th style={{width:150}}>  <input type= "text"  onChange = {this.setTransporterTable} className= "form-control inp-search" id="transportCity" placeholder= "City" /></th>
											<th style={{width:90}}>  <input type= "text"  onChange = {this.setTransporterTable} className= "form-control inp-search" id="transportPhone"  placeholder= "Phone" /></th>
										</tr>
									</thead>
								</table>
								<div className="transportTableDiv col-sm-12 col-xs-11 padding-remove">
									<table id="transportTable" className="tableLayout">
										<colgroup>
											<col width="110" />
											<col width="130" />
											<col width="150" />
											<col width="150" />
											<col width="90" />
										</colgroup>
										<tbody id="transportTableBody"></tbody>
									</table>
								</div>
							</div>
							<div className="col-sm-1 col-xs-1">
								<span id="addTransporter" title="Add Transport" onClick={this.clear} className="addIcon glyphicon glyphicon-plus-sign"></span>
							</div>
							<div className="col-sm-4 col-xs-12">
								<form id="transportAddForm" className="form-horizontal">
									<div className="form-group">
										<label className="control-label col-sm-5">Transporter:</label>
										<div className="col-sm-7">
											<input type="text" className="form-control" placeholder="Transporter Name" id="inp_transporter"/>
										</div>
									</div>
									<div className="form-group">
										<label className="control-label col-sm-5">Contact Person:</label>
										<div className="col-sm-7">
											<input type="text" className="form-control" placeholder="Contact person" id="inp_contactPerson"/>
										</div>
									</div>
									<div className="form-group">
										<label className="control-label col-sm-5">City:</label>
										<div className="col-sm-7">
										<select style={{height:32}} className="form-control" id="inp_contactCity" ></select>
										</div>
									</div>
									<div className="form-group">
										<label className="control-label col-sm-5">Phone:</label>
										<div className="col-sm-7">
											<input type="text" maxLength="10" className="form-control" placeholder="Phone" id="inp_phone"/>
										</div>
									</div>
								   <div className="form-group" style={{marginTop:10}}>
										<div className="col-sm-12 text-center">
											<button type="button"  className="btn btn-warning" onClick={this. maintainTransport}>Save</button>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	};
}

export default MaintainTransporter;